module.exports = __webpack_public_path__ + "static/img/top_2_2.bb9c963b.jpg";